import linesLeftPM from '#app/assets/images/decorative/lines-left-pm.svg'
import linesRightPM from '#app/assets/images/decorative/lines-right-pm.svg'
import { CardImageTextExt } from '#app/components/ui/card-image-text-ext.tsx'
import { Tag } from '#app/components/ui/tag.tsx'

interface ActionsSectionProps {
	className?: string
}

export default function ActionsSection({ className }: ActionsSectionProps) {
	const actions = [
		{
			image:
				'/resources/images?src=/img/programa-madre/taller-educativo.png&w=200&h=208&format=webp',
			title: 'Proyectos educativos y de sensibilización ambiental',
			description:
				'Desarrollamos iniciativas educativas para generar conciencia sobre la importancia del agua y su conservación, trabajando directamente con comunidades y escuelas del territorio.',
		},
		{
			image:
				'/resources/images?src=/img/fondo-de-agua/hombre-trabajando.png&w=200&h=208&format=webp',
			title: 'Campañas de restauración ecológica y forestación',
			description:
				'Implementamos acciones de restauración de ecosistemas y forestación con especies nativas para proteger las fuentes de agua y mejorar la calidad hídrica.',
		},
		{
			image:
				'/resources/images?src=/img/fondo-de-agua/manos-hojas.png&w=200&h=208&format=webp',
			title: 'La conexión entre el conocimiento técnico-científico y la acción',
			description:
				'Facilitamos el vínculo entre la investigación científica y la implementación de soluciones prácticas basadas en evidencia para la gestión sostenible del agua.',
		},
		{
			image:
				'/resources/images?src=/img/fondo-de-agua/personas-convenios.png&w=200&h=208&format=webp',
			title: 'La articulación con otras organizaciones y redes',
			description:
				'Fortalecemos alianzas estratégicas con actores públicos, privados y de la sociedad civil para amplificar el impacto de nuestras acciones por el agua.',
		},
	]

	return (
		<section className={`relative bg-white ${className || ''}`}>
			{/* Decorative background elements */}
			<div
				className="pointer-events-none absolute inset-0 overflow-hidden"
				aria-hidden="true"
			>
				{/* Left lines with gradient overlay */}
				<div className="absolute top-[-200px] left-[-333.98px] h-[1608.14px] w-[1666.46px]">
					<img
						src={linesLeftPM}
						alt=""
						className="drop-shadow-glow-brand h-full w-full object-contain"
					/>
				</div>

				{/* Right lines with gradient overlay */}
				<div className="absolute top-[-199.89px] left-[720.76px] h-[1442.20px] w-[1509.64px]">
					<img
						src={linesRightPM}
						alt=""
						className="drop-shadow-glow-brand h-full w-full object-contain"
					/>
				</div>
			</div>

			<div className="relative z-10 container mx-auto max-w-[1200px] px-[37.5px] py-16 md:px-4 md:py-16">
				<div className="flex flex-col gap-16 md:flex-row md:gap-16">
					{/* Left Column - Sticky Title */}
					<div className="md:sticky md:top-0 md:h-fit md:w-[568px] md:shrink-0 md:py-16">
						<div className="flex flex-col gap-16">
							{/* Tag */}
							<div>
								<Tag
									variant="secondary"
									appearance="solid"
									color="blue"
									size="l"
									option="text-icon-left"
									leftIcon="service"
								>
									Compromiso
								</Tag>
							</div>

							{/* Title */}
							<h2 className="font-parkinsans text-txt-primary text-4xl leading-[70px] font-medium md:text-[56px]">
								¿Cómo aportamos?
							</h2>
						</div>
					</div>

					{/* Right Column - Action Cards */}
					<div className="flex flex-1 flex-col gap-8">
						{actions.map((action, index) => (
							<CardImageTextExt
								key={index}
								layout="horizontal"
								state="default"
								showImage={true}
								image={action.image}
								imageAlt={action.title}
								showChip={false}
								showIcon={false}
								title={action.title}
								showDescription={true}
								description={action.description}
								showButton={false}
								showButton2={false}
							/>
						))}
					</div>
				</div>
			</div>
		</section>
	)
}
